// Toggle resume search alert  ***********************
// pathname: /v1/resume-search-alert/toggle/{id}
// **********************************************************
import { GenericV1ErrorsArray, useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrToggleResumeSearchAlertProps {
  locale?: Locale;
  id: string;
  channel?: number;
  successCallback?: () => void;
  errorCallback?: (errors: GenericV1ErrorsArray) => void;
}

/**
 * @description SWR mutation: Toggle resume search alert by id and optional channel.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param id - string. The id of the resume search alert to toggle.
 * @param channel - number. The channel of notification to toggle.
 * @param successCallback - function. The callback to execute after successful toggle.
 * @param errorCallback - function. The callback to execute on error.
 */
export const useSwrToggleResumeSearchAlert = (props: UseSwrToggleResumeSearchAlertProps) => {
  const {
    locale = 'ro',
    id,
    channel,
    successCallback,
    errorCallback,
  } = props;

  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<ApiSchema<'ResumeSearchAlertData'>, never>({
    url: `/v1/resume-search-alert/toggle/${id}${channel !== undefined ? `?channel=${channel}` : ''}`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: (errors) => {
        if (errorCallback) errorCallback(errors);
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};

